export default [
  { Id: 1, Name: "African union" },
  { Id: 2, Name: "Agriculture/Processing facility" },
  { Id: 3, Name: "Airport" },
  { Id: 4, Name: "Army " },
  { Id: 5, Name: "ATM" },
  { Id: 6, Name: "Bank branch" },
  { Id: 7, Name: "Bar" },
  { Id: 8, Name: "Bridge" },
  { Id: 9, Name: "Cargo aircraft" },
  { Id: 10, Name: "Cargo vessel" },
  { Id: 11, Name: "Cash in transit" },
  { Id: 12, Name: "Christian asset" },
  { Id: 13, Name: "Clinic" },
  { Id: 14, Name: "Coal plant" },
  { Id: 15, Name: "Commercial aircraft" },
  { Id: 16, Name: "Community centre" },
  { Id: 17, Name: "Dam" },
  { Id: 18, Name: "Educational research facility" },
  { Id: 19, Name: "Embassy and consulate" },
  { Id: 20, Name: "EU" },
  { Id: 21, Name: "Gas plant" },
  { Id: 22, Name: "Guard" },
  { Id: 23, Name: "Hindu asset" },
  { Id: 24, Name: "Hotel" },
  { Id: 25, Name: "Hydro plant" },
  { Id: 26, Name: "Jewish asset" },
  { Id: 27, Name: "Laboratory" },
  { Id: 28, Name: "Land/Property" },
  { Id: 29, Name: "Legal" },
  { Id: 30, Name: "Library" },
  { Id: 31, Name: "Livestock" },
  { Id: 32, Name: "Medical research facility" },
  { Id: 33, Name: "Military barrack" },
  { Id: 34, Name: "Military base" },
  { Id: 35, Name: "Mining site" },
  { Id: 36, Name: "Ministry" },
  { Id: 37, Name: "Monument" },
  { Id: 38, Name: "Museum" },
  { Id: 39, Name: "Muslim asset" },
  { Id: 40, Name: "NATO" },
  { Id: 41, Name: "Nightclub" },
  { Id: 42, Name: "Nuclear power plant" },
  { Id: 43, Name: "Office building" },
  { Id: 44, Name: "Oil/Gas terminal" },
  { Id: 45, Name: "Other religious asset" },
  { Id: 46, Name: "Park" },
  { Id: 47, Name: "Parliament" },
  { Id: 48, Name: "Passenger vessel" },
  { Id: 49, Name: "Pipeline" },
  { Id: 50, Name: "Place of worship" },
  { Id: 51, Name: "Police station" },
  { Id: 52, Name: "Policeman" },
  { Id: 53, Name: "Political party/group" },
  { Id: 54, Name: "Port/Terminal" },
  { Id: 55, Name: "Printed Press" },
  { Id: 56, Name: "Prison and Detention facility" },
  { Id: 57, Name: "Pump station" },
  { Id: 58, Name: "Pylon/Wire" },
  { Id: 59, Name: "Radio tower/Antenna" },
  { Id: 60, Name: "Refinery" },
  { Id: 61, Name: "Residence" },
  { Id: 62, Name: "Restaurant" },
  { Id: 63, Name: "Road" },
  { Id: 64, Name: "School" },
  { Id: 65, Name: "Shopping Mall" },
  { Id: 66, Name: "Shop/Store" },
  { Id: 67, Name: "Sikh asset" },
  { Id: 68, Name: "Solar plant" },
  { Id: 69, Name: "Soldier" },
  { Id: 70, Name: "Square" },
  { Id: 71, Name: "Stadium" },
  { Id: 72, Name: "Brokerage" },
  { Id: 73, Name: "Sub-Station" },
  { Id: 74, Name: "Television" },
  { Id: 75, Name: "Theatre/Concert hall" },
  { Id: 76, Name: "Tunnel" },
  { Id: 77, Name: "University" },
  { Id: 78, Name: "Vehicle" },
  { Id: 79, Name: "Wind Farm" },
  { Id: 80, Name: "Women's care clinic" },
  { Id: 81, Name: "Zoo" },
  { Id: 82, Name: "Immigrant" },
  { Id: 83, Name: "Expatriate" },
  { Id: 84, Name: "Refugee" },
  { Id: 85, Name: "Local government" },
  { Id: 86, Name: "Warehouse" },
  { Id: 87, Name: "Central government" },
  { Id: 88, Name: "Bus" },
  { Id: 89, Name: "UN" },
  { Id: 90, Name: "Apparel" },
  { Id: 91, Name: "Infrastructure" },
  { Id: 92, Name: "Railway track" },
  { Id: 93, Name: "Railway station" },
  { Id: 94, Name: "Courthouse" },
  { Id: 95, Name: "Presidential palace" },
  { Id: 96, Name: "Stock exchange" },
  { Id: 97, Name: "Public official" },
  { Id: 98, Name: "Personnel" },
  { Id: 99, Name: "Water supply" },
  { Id: 100, Name: "Train" },
  { Id: 101, Name: "Subway" },
  { Id: 102, Name: "Military aircraft" },
  { Id: 103, Name: "Factory" },
  { Id: 104, Name: "Unknown" },
  { Id: 105, Name: "Buddhist asset" },
  { Id: 106, Name: "Combatant" },
];
